<template>
  <div>  
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/rum">Alla rum</router-link>
        <router-link tag="li" to="/rum/ny">Skapa ett nytt rum</router-link>
      </ul>
      <div class="clear"></div>
    </div>
    
    <div class="form">
      <div class="item">
        <div class="label">Namn</div>
        <div><input type="text" @keyup="searchMatchingImage" v-model="name" placeholder="Namn"></div>
      </div>
      
      <div class="item">
        <div class="label">Bild</div>
        <div>
          <select v-model="backURL">
            <optgroup label="Egen bild">
              <option value="egen">Ladda upp egen bild...</option>
            </optgroup>
            
            <optgroup label="Standardbilder">
              <option v-for="room in roomImages" :value="room.image">{{ room.name }}</option>
            </optgroup>
          </select>
        </div>      
        <div class="descr">När du väljer en bild ovan kommer du att få en förhandsvisning på hur den ser ut.</div>
      </div>

      <div class="item">
        <div class="label">Enheter</div>
        <div>
          <select v-model="nodes" multiple style="height:200px;" @change="changeNode">
            <option v-for="node in $root.data.nodes" :value="node.id">{{ node.name || 'Inget namn' }}</option>
          </select>
        </div>
      </div>

      <div class="item" v-if="backURL !== 'egen' && backURL.length">
        <div class="label">Din valda bild</div>
        <div>
          <img v-if="backURL.length" style="border:1px solid #d2d2d2;width:100%;height:300px;object-fit:cover;" :src="backURL">
        </div>
      </div>

      <div class="item" v-if="backURL == 'egen'">
        <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-file-added="didAddImage = true" v-on:vdropzone-success="doneUpload"></vue-dropzone>
      </div>
      
      <button @click="save" :disabled="!ok" v-if="!didAddImage">{{ saving ? 'Sparar...' : 'Spara rummet' }}</button>
      <button @click="upload" v-if="didAddImage">{{ uploading ? 'Laddar upp bild...' : 'Ladda upp bild' }}</button>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.css'

  export default {
    name: 'HelloWorld',
    components: {
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        roomImages: [],
        backURL: '',
        name: '',
        saving: false,
        dropzoneOptions: {
          url: 'https://app.nexabridge.se/room/upload?from=web',
          method: 'POST',
          paramName: 'file',
          multiple: false,
          maxFiles: 1,
          autoProcessQueue: false,
          maxFilesize: 3,
          acceptedFiles: '.png,.jpg,.jpeg'
        },
        didAddImage: false,
        uploading: false,
        nodes: [],
        nodes2: [],
        editing: false
      }
    },
    created () {
      fetch('https://app.nexabridge.se/rooms')
      .then(res => res.json())
      .then(json => {
        this.roomImages = json.map(room => {
          room.name = room.name.replace('.jpg', '')
          room.name = room.name.charAt(0).toUpperCase() + room.name.substring(1)
          return room
        })
      })
      
      //this.roomImages = require('../rooms.json')

      this.editing = ('id' in this.$route.params)
      if (this.editing) {
        const room = this.$root.data.rooms.find(room => room.id === this.$route.params.id)
        
        this.id = room.id
        this.name = room.name
        this.backURL = room.backURL
        this.nodes = this.$root.data.nodes.filter(node => node.roomId === this.id).map(node => node.id)
        this.nodes2 = this.nodes
      }
    },
    methods: {
      doneUpload (file, json) {
        if ('success' in json) {
          this.backURL = json.url
          this.uploading = false
          
          // Om allt är okej (namn, enheter, etc) när uppladdningen är klar
          // så låter sparar vi rummet direkt.
          if (this.ok) {
            this.save()
          }
        }
      },
      
      changeNode () {

      },
      
      basename (path) {
        return path.replace(/\\/g,'/').replace( /.*\//, '' )
      },

      searchMatchingImage () {
        if (this.backURL !== 'egen') {
          if (this.name.length) {
            let test = this.roomImages.filter(url => {
              return url.includes(this.name.toLowerCase())
            })
            
            if (test && test.length == 1) {
              this.backURL = test[0]
            }
          } else {
            this.backURL = ''
          }
        }
      },

      upload () {
        this.uploading = true
        this.$refs.myVueDropzone.processQueue()
        this.didAddImage = false
      },

      save () {
        this.saving = true
        
        let path = 'rooms'
        if (this.editing) {
          path += '/' + this.id
        }

        HTTP.post(path, {
          name: this.name,
          backURL: this.backURL
        })
        .then(res => res.data)
        .then(json => {
          if (this.editing) {
            let room = this.$root.data.rooms.find(room => room.id === this.id)
            room.name = this.name
            room.backURL = this.backURL
          } else {
            this.$root.data.rooms.push({
              id: json.id,
              name: this.name,
              backURL: this.backURL
            })
          }

          // Uppdatera noderna med det nya IDt
          if (this.nodes.length) {
            this.nodes.forEach(nodeId => {
              let node = this.$root.data.nodes.find(node => node.id === nodeId)
              node.roomId = (this.editing ? this.id : json.id)

              HTTP.post('nodes/' + nodeId, {
                roomId: node.roomId
              })
            })
          }

          this.$router.push({ name: 'rum' })
        })
      }
    },
    computed: {
      ok () {
        return this.name.length && this.backURL.length && this.backURL !== 'egen' && !this.saving && this.nodes.length
      }
    }
  }
</script>

<style scoped>
  .room {
    transition:all 0.3s ease;
    cursor:pointer;
  }
  
  .room:hover {
      -webkit-transform: scale(0.99);
        -ms-transform: scale(0.99);
        transform: scale(0.99);
  }
</style>


// WEBPACK FOOTER //
// src/components/rum_nytt.vue